import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'
import { sessionSetItemStr } from '../../../utils/sessionHelpers'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'

export default function ClosureApproveRequestTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  isViewMode,
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>เลขที่คำขอปิด</HeaderCell>
          <Cell dataKey="closureDocNo" />
        </Column>
        <Column width={130}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={250} minWidth={250} flexGrow={1}>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={170}>
          <HeaderCell>ประเภทการขอปิด</HeaderCell>
          <Cell dataKey="closureType" />
        </Column>

        <Column width={140}>
          <HeaderCell>วันที่ขอปิด</HeaderCell>
          <Cell dataKey="requestDate" />
        </Column>

        <Column width={150} align="right">
          <HeaderCell>จำนวนครุภัณฑ์</HeaderCell>
          <Cell>
            {(rowData) => {
              return <span>{numberThousandSeparator(rowData.totalAsset || 0)}</span>
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell align="right">รวมมูลค่า</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.price)
            }}
          </Cell>
        </Column>

        <Column width={200} align="center">
          <HeaderCell>สถานะการขอปิด</HeaderCell>
          <Cell dataKey="status" />
        </Column>

        {!isViewMode && (
          <Column width={140} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.disable) {
                  return (
                    <ViewButton
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      แสดง
                    </ViewButton>
                  )
                } else {
                  return (
                    <SaveButton
                      icon="pencil"
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      จัดการ
                    </SaveButton>
                  )
                }
              }}
            </Cell>
          </Column>
        )}
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
